import React from 'react';
import Gauge from 'react-svg-gauge';

interface GaugeChartProps {
  score: number;
}
const GaugeChart: React.FC<GaugeChartProps> = (props) => {
  const { score } = props;
  return (
    <div>
      <Gauge
        color={'#12c0f0'}
        value={score}
        width={107}
        height={54}
        label=''
        minMaxLabelStyle={{ display: 'none' }}
        valueFormatter={(val: number) => `${val} %`}
        valueLabelStyle={{ fontSize: 16 }}
      />
    </div>
  );
};

export default GaugeChart;
